"use strict"
var $ = avm.require('cash');
if (typeof $_ !== 'undefined') {
    $ = $_;
}



//Form management
var $btnContactFrom = $('.btn-modal-contactForm'),
    $modal_textForReplace = $('.js-modal-btn-text', 0),
    $modal_whitepapersButtons = $('.js-modal-whitepapersForm');

// Open contact form modal
$btnContactFrom.on('click', function () {
    $modal_whitepapersButtons.removeClass('activeLink');
    $('#carriers-contact-form').load('carriers-contact-form', function () {
        initAvastForm();
        $('#carriers-contact-form').siblings().show();
        $('#carriers-contact-form').find('input.button[type="submit"]').removeClass('button blue large').addClass('btn btn-primary btn-lg')
    })
})

// Open whitepapers form modals
$modal_whitepapersButtons.on('click', function (e) {
    $modal_whitepapersButtons.removeClass('activeLink');
    $(this).addClass('activeLink');
    $('#carriers-whitepapers-form').load('carriers-contact-form', function () {
        initAvastForm();
        $('#carriers-whitepapers-form').siblings().show();
        $('#carriers-whitepapers-form').find('input.button[type="submit"]').attr('value', $modal_textForReplace.text()).removeClass('button blue large').addClass('btn btn-primary btn-lg');
    })
})

// Contact form after success
$(document).on('avastform-linear-success', function () {
    initAvastForm();
    if ($($modal_whitepapersButtons).hasClass('activeLink')) {
        window.open($('.js-modal-whitepapersForm.activeLink').attr('href'), '_blank');
        $modal_whitepapersButtons.removeClass('activeLink');
    }
    $('#carriers-whitepapers-form').siblings().hide();
    $('#carriers-contact-form').siblings().hide();
});

function finishForm(){
    initAvastForm();
    if ($($modal_whitepapersButtons).hasClass('activeLink')) {
        window.open($('.js-modal-whitepapersForm.activeLink').attr('href'), '_blank');
        $modal_whitepapersButtons.removeClass('activeLink');
    }
    $('#carriers-whitepapers-form').siblings().hide();
    $('#carriers-contact-form').siblings().hide();
}

